import React from 'react';
import { Search, Filter } from 'lucide-react';

const SearchResultsInfo = ({ 
    searchResults, 
    searchTerm, 
    searchLoading, 
    totalResults, 
    filteredCandidatesLength, 
    onClearSearch,
    hasAdvancedFilters = false
}) => {
    // Don't show if no search term and no advanced filters
    if (searchResults === null) return null;

    // Build description of what's being filtered
    let filterDescription = '';
    const hasSearchTerm = searchTerm && searchTerm.trim().length > 0;
    
    if (hasSearchTerm && hasAdvancedFilters) {
        filterDescription = `"${searchTerm}" with applied filters`;
    } else if (hasSearchTerm) {
        filterDescription = `"${searchTerm}"`;
    } else if (hasAdvancedFilters) {
        filterDescription = 'applied filters';
    }

    return (
        <div className="bg-[#ffff] border-b px-6 py-2 flex items-center justify-between flex-shrink-0">
            <div className="flex items-center gap-2">
                <div className="flex items-center gap-1">
                    {hasSearchTerm && <Search className="w-4 h-4 text-[#275F97]" />}
                    {hasAdvancedFilters && <Filter className="w-4 h-4 text-[#275F97]" />}
                </div>
                <span className="text-sm text-[#275F97]">
                    {searchLoading ? (
                        'Searching...'
                    ) : (
                        <>
                            Found <strong>{totalResults}</strong> results
                            {filterDescription && (
                                <> for {filterDescription}</>
                            )}
                            {filteredCandidatesLength !== totalResults && (
                                <span className="text-[#275F97]"> ({filteredCandidatesLength} shown after status filters)</span>
                            )}
                        </>
                    )}
                </span>
            </div>
        </div>
    );
};

export default SearchResultsInfo;